import { UncubesQuery } from '@dynameat/views/reporting/models/uncubesQuery';

export class EvolutiveQuery extends UncubesQuery {
  projection = 'ticket_sales'

  cuts = []

  cols = []

  orderBy = [{
    kpi: 'ticket_line_date',
    order: 'ASC'
  }]

  rows = [{
    kpi: 'ticket_line_date'
  }]

  aggregates = [
    { kpi: 'ticket_line_unit_price', function: 'AVG' },
    { kpi: 'ticket_line_amount', function: 'AVG' },
    { kpi: 'ticket_line_cost', function: 'AVG' },
    { kpi: 'ticket_line_normal_quantity', function: 'SUM' },
  ]

  limit = 100

  // YYYY-MM-DD date with timezone taken in account
  getDateForQuery(date) {
    const offset = date.getTimezoneOffset();
    const offsetDate = new Date(date.getTime() - (offset * 60 * 1000));
    return offsetDate.toISOString().split('T')[0];
  }

  constructor(productGuid, startDate, endDate, serviceGuid) {
    super();
    if (startDate instanceof Date) {
      startDate = this.getDateForQuery(startDate);
    }
    if (endDate instanceof Date) {
      endDate = this.getDateForQuery(endDate);
    }
    // We need this because uncubes seem to do the intervals open in the end, i.e. excluding the
    // last term
    const realEndDate = new Date();
    realEndDate.setDate(new Date(endDate).getDate() + 1);
    const realDateString = this.getDateForQuery(realEndDate);
    const diffTime = Math.abs(new Date(startDate) - new Date(realEndDate));
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    this.cuts = [
      { expression: `ticket_line_date between '${startDate}' and '${realDateString}'` },
      { expression: `product_guid = '${productGuid}'` }
    ];

    if (serviceGuid) this.cuts.push({ expression: `service_guid = '${serviceGuid}'` });

    this.limit = diffDays;
  }
}
